import React from "react";
import Section from "../components/section/section";
import { useStore } from "../store";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";
import Hexagon3 from "../components/hexagon-3";

export default function EndFrame12() {
  const { section, setSection, showEndFrame } = useStore();

  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 1.2 || !showEndFrame) return null;

  return (
    <Section name="1-2">
      <HexagonButton
        onClick={() => setSection(1.1)}
        disabled={watchedSections.includes(1.1)}
      >
        <div>
          Get stuck into
          <br />
          emails
        </div>
        <Hexagon1 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(1.2)}
        disabled={watchedSections.includes(1.2)}
      >
        <div>Have a work out</div>
        <Hexagon2 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(1.3)}
        disabled={watchedSections.includes(1.3)}
      >
        <div>Get a coffee</div>
        <Hexagon3 />
      </HexagonButton>
    </Section>
  );
}
